/**
 * @generated SignedSource<<a2711501a179c66b2f9270ba57d56bec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillAssessmentsByStudentFilterInput = {
  skillCode?: string | null | undefined;
  skillId?: string | null | undefined;
};
export type SingleSkillQuery$variables = {
  filter?: SkillAssessmentsByStudentFilterInput | null | undefined;
  studentId: string;
};
export type SingleSkillQuery$data = {
  readonly skillAssessmentsByStudentId: {
    readonly nodes: ReadonlyArray<{
      readonly activityId: string | null | undefined;
      readonly score: number;
      readonly sessionCompletedOn: any;
      readonly skill: {
        readonly id: string;
      } | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type SingleSkillQuery = {
  response: SingleSkillQuery$data;
  variables: SingleSkillQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studentId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "studentId",
    "variableName": "studentId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activityId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "skill",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionCompletedOn",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SingleSkillQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StudentSkillAssessmentNodeConnection",
        "kind": "LinkedField",
        "name": "skillAssessmentsByStudentId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentSkillAssessmentNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SingleSkillQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StudentSkillAssessmentNodeConnection",
        "kind": "LinkedField",
        "name": "skillAssessmentsByStudentId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentSkillAssessmentNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b7316e90221e1583ba6187b6c2b72ac",
    "id": null,
    "metadata": {},
    "name": "SingleSkillQuery",
    "operationKind": "query",
    "text": "query SingleSkillQuery(\n  $studentId: ID!\n  $filter: SkillAssessmentsByStudentFilterInput\n) {\n  skillAssessmentsByStudentId(studentId: $studentId, filter: $filter) {\n    nodes {\n      activityId\n      skill {\n        id\n      }\n      score\n      sessionCompletedOn\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba5a5647068269d9ee6ae30e31109382";

export default node;
